import type { FilterLocation } from "../types"

let location: FilterLocation = {
    slug: SearchConfig.location.slug,
    name: SearchConfig.location.name,
    id: SearchConfig.location.id,
    postalCodes: SearchConfig.location.postalCodes,
    // TODO make dynamic
    type: "ort",
}

export function setFilterLocation(newLocation: FilterLocation) {
    location = newLocation
}

export function getLocation() {
    return location
}

export function getLocationAsString() {
    return location.slug || ""
}

export function parseLocationFromLocation() {
    // http://localhost:8081/frankfurt-main/sex-anzeigen/figur:skinny,mollig,dick;busen:dick?umkreis=300
    const pathSplit = window.location.pathname.split("/")
    if (pathSplit[1] !== "sex-anzeigen") {
        location.slug = pathSplit[1]
    }
}

parseLocationFromLocation()
